if (!customElements.get('pinned-products-quick-add')) {
  class PinnedProductsQuickAdd extends HTMLElement {

    constructor() {
      super();
      this.button = this.querySelector('button');
    }

    connectedCallback() {

      if (this.button) {
        this.enableQuickview();
      }
    }

    enableQuickview() {
      const drawer = document.getElementById('Product-Drawer');
      const body = document.body;
      const button = this.button;

      button.addEventListener('click', (evt) => {
        evt.preventDefault();
        evt.stopPropagation();

        button.setAttribute('aria-expanded', 'true');

        const productHandle = this.dataset.productHandle;
        const variantId = this.dataset.variantId;

        let href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`;

        href = href.replace('//', '/');

        if (!href || !productHandle) return;
        if (button.classList.contains('loading')) return;

        button.classList.add('loading');

        fetch(href, { method: 'GET' })
          .then(response => {
            button.classList.remove('loading');
            return response.text();
          })
          .then(text => {

            const html = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('#Product-Drawer-Content').innerHTML;

            this.renderQuickview(html, drawer, body, href, productHandle, variantId);
          });
      });
    }

    renderQuickview(sectionInnerHTML, drawer, body, href, productHandle, variantId) {
      if (!sectionInnerHTML) return;

      drawer.querySelector('#Product-Drawer-Content').innerHTML = sectionInnerHTML;

      setTimeout(() => {
        if (Shopify && Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }
      }, 300);

      body.classList.add('open-cc');
      body.classList.add('open-quick-view');
      drawer.classList.add('active');

      setTimeout(() => {
        drawer.querySelector('.product-quick-images--container')?.classList.add('active');
      });

      drawer.querySelector('.side-panel-close')?.focus();

      dispatchCustomEvent('quick-view:open', {
        productUrl: href,
        productHandle: productHandle,
        variantId: variantId
      });
    }
  }

  customElements.define('pinned-products-quick-add', PinnedProductsQuickAdd);
}
